import { NgModule } from '@angular/core';
import { ComboBoxModule } from '@wuitk/angular/components/combobox';
import { DropDownModule } from '@wuitk/angular/components/dropdown';
import { CommonModule as WuitkCommonModule } from '@wuitk/angular/components/common';
import { MultiselectModule } from '@wuitk/angular/components/multiselect';
import { StepperModule } from '@wuitk/angular/components/stepper';
import { TextModule } from '@wuitk/angular/components/text';
import { ToggleSwitchModule } from '@wuitk/angular/components/toggleswitch';
import { ButtonModule } from '@wuitk/angular/components/button';
import { RadioButtonModule } from '@wuitk/angular/components/radiobutton';
import { LabelModule } from '@wuitk/angular/components/label';
import { MenuModule } from '@wuitk/angular/components/menu';
import { TabsModule } from '@wuitk/angular/components/tabs';
import { SearchTextBoxModule } from '@wuitk/angular/components/searchbox';
import { AutocompleteModule } from '@wuitk/angular/components/autocomplete';
import { DialogModule } from '@wuitk/angular/components/dialog';
import { PopUpModule } from '@wuitk/angular/components/popup';
import { ListViewModule } from '@wuitk/angular/components/listview';
import { AccordionModule } from '@wuitk/angular/components/accordion';
import { ExpanderModule } from '@wuitk/angular/components/expander';
import { ProgressIndicatorModule } from '@wuitk/angular/components/progress-indicator';
import { NotificationModule } from '@wuitk/angular/components/notification';
import { PaginatorModule } from '@wuitk/angular/components/paginator';
import { LoginModule } from '@wuitk/angular/components/login-screen';
import { PasswordModule } from '@wuitk/angular/components/password-box';
import { ValidationMessageModule } from '@wuitk/angular/components/validation-message';
import { LinkModule } from '@wuitk/angular/components/link';
import { SpringBoardModule } from '@wuitk/angular/components/springboard';
import { AboutModule } from '@wuitk/angular/components/about-screen';
import { RichEditboxModule } from '@wuitk/angular/components/rich-editbox';
import { TooltipModule } from '@wuitk/angular/components/tooltip';
import { SideBarModule } from '@wuitk/angular/components/side-bar';

const dlsModules = [
  ComboBoxModule,
  DropDownModule,
  WuitkCommonModule,
  MultiselectModule,
  StepperModule,
  TextModule,
  ToggleSwitchModule,
  ButtonModule,
  RadioButtonModule,
  LabelModule,
  MenuModule,
  TabsModule,
  SearchTextBoxModule,
  AutocompleteModule,
  DialogModule,
  PopUpModule,
  ListViewModule,
  AccordionModule,
  ExpanderModule,
  ProgressIndicatorModule,
  NotificationModule,
  PaginatorModule,
  SpringBoardModule,
  PaginatorModule,
  LoginModule,
  PasswordModule,
  ValidationMessageModule,
  LinkModule,
  AboutModule,
  RichEditboxModule,
  TooltipModule,
  SideBarModule
];

@NgModule({
  imports: [
    dlsModules
  ],
  exports: [
    dlsModules
  ]
})

export class DlsSharedModule { }
